import { CSSProperties } from "react";

import { Switch } from "@components/Switch";
import { Body, Title4 } from "@components/Typography";
import { i18n, Translations } from "@i18n";
import { useStyles } from "./styles";
import { TaxGainHarvestOptionsProps } from "./types";

export const TaxGainHarvestOptions = ({
  standardDeduction,
  longTermCapitalGains,
  onStandardDeductionChange,
  onLongTermCapitalGainsChange,
  disabled = false,
  style,
}: TaxGainHarvestOptionsProps) => {
  const styles = useStyles();

  const wrapStyle: CSSProperties = disabled
    ? { ...styles.container, ...style, opacity: 0.5, pointerEvents: "none" }
    : { ...styles.container, ...style };

  return (
    <div style={wrapStyle}>
      <div style={styles.option}>
        <div style={styles.optionText}>
          <Title4 style={styles.optionTitle}>
            {i18n.t(Translations.TaxGainHarvestRouteStandardDeductionTitle)}
          </Title4>
          <Body style={styles.optionSubtitle}>
            {i18n.t(Translations.TaxGainHarvestRouteStandardDeductionDescription)}
          </Body>
        </div>
        <div onClick={(e) => e.stopPropagation()} role="presentation">
          <Switch
            checked={standardDeduction}
            onChange={() => onStandardDeductionChange(!standardDeduction)}
          />
        </div>
      </div>
      <div style={styles.option}>
        <div style={styles.optionText}>
          <Title4 style={styles.optionTitle}>
            {i18n.t(Translations.TaxGainHarvestRouteLongTermCapitalGainsTitle)}
          </Title4>
          <Body style={styles.optionSubtitle}>
            {i18n.t(Translations.TaxGainHarvestRouteLongTermCapitalGainsDescription)}
          </Body>
        </div>
        <div onClick={(e) => e.stopPropagation()} role="presentation">
          <Switch
            checked={longTermCapitalGains}
            onChange={() => onLongTermCapitalGainsChange(!longTermCapitalGains)}
          />
        </div>
      </div>
    </div>
  );
};
